import React from 'react';
import { motion } from 'framer-motion';
import DonationCTA from '../components/DonationCTA';

const GetInvolvedPage = () => {
  return (
    <div className="pt-16">
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Get Involved</h1>
            <p className="text-xl text-gray-600">
              Join us in creating a begging-free India through your support and involvement
            </p>
          </motion.div>
        </div>
      </section>
      <DonationCTA />
    </div>
  );
};

export default GetInvolvedPage;